<svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
  <circle cx="25" cy="5" r="5" />
  <circle cx="5" cy="25" r="5" />
  <circle cx="45" cy="25" r="5" />
  <circle cx="11" cy="11" r="5" />
  <circle cx="11" cy="39" r="5" />
  <circle cx="39" cy="11" r="5" />
  <circle cx="39" cy="39" r="5" />
</svg>
